import { useCallback } from 'react'
import { useHistory } from 'react-router-dom'

import { useUpdateUserActivationDataMutation } from 'common'

import { patchBrandRefreshActivationData } from './brandRefreshActivationData'
import { queueBrandRefreshWelcomeModal } from './brandRefreshWelcomeSession'
import { BRAND_REFRESH_OPT_IN_DESTINATION_PATH, BRAND_REFRESH_OPT_IN_SOURCES } from './constants'

type OptInSource = typeof BRAND_REFRESH_OPT_IN_SOURCES[keyof typeof BRAND_REFRESH_OPT_IN_SOURCES]

/**
 * Persists product-refresh opt-in to `activation_data.brand_refresh_beta`.
 * The refreshed experience stays off by default until `opted_in` is true.
 */
export function useOptInToBrandRefresh() {
  const [updateActivationData, { isLoading }] = useUpdateUserActivationDataMutation()
  const history = useHistory()

  const optIn = useCallback(
    async (source: OptInSource) => {
      await updateActivationData((existing) => patchBrandRefreshActivationData(
        existing,
        { opted_in: true },
      )).unwrap()
      queueBrandRefreshWelcomeModal()
      // Defer until the post opt-in shell swap commits before loading meeting types.
      requestAnimationFrame(() => {
        history.push(BRAND_REFRESH_OPT_IN_DESTINATION_PATH)
      })
    },
    [history, updateActivationData],
  )

  return { optIn, isLoading }
}
